import styled from "styled-components";

export const RootContentContainer = styled.div<{ is_sidebar_toggled: boolean }>`
  background-color: #f7f8fc;
  position: relative;
  z-index: 1;
  left: ${(props) => (props.is_sidebar_toggled ? "0px" : "-255px")};
  min-width: ${(props) => (props.is_sidebar_toggled ? "calc(100vw - 255px)" : "100vw")};
  transition: left 1s, min-width 1s;
  @media (max-width: 575.98px) {
    min-width: 100vw;
  }
`;
